import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
var _hoisted_2 = {
  style: {
    "margin-left": "6px"
  }
};
import { createIconNode } from '@/component-create/utils/common';
import { debounce } from '@/utils/common';
import { ElRow, ElForm } from 'element-plus';
import 'element-plus/es/components/row/style/css'
import 'element-plus/es/components/form/style/css'


import { ref, computed, onMounted, onUnmounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ExpForm',
  props: {
    model: {},
    labelWidth: {}
  },
  emits: ["search", "reset"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var formRef = ref();
    var rowRef = ref();
    var expansion = ref(true);
    var showExpansion = ref(true);
    var orgDisplay = ref([]);
    var colspan = ref(6);
    var rowMaxCol = computed(function () {
      return 24 / colspan.value;
    });
    function search() {
      emits('search', props.model);
    }
    function reset() {
      emits('reset', formRef);
    }
    function handleExpansion() {
      expansion.value = !expansion.value;
      var child = getChildren();
      // 展开
      if (expansion.value) {
        child.forEach(function (item, index) {
          child[index].style.display = orgDisplay.value[index];
        });
      } else {
        // 收起
        child.forEach(function (item, index) {
          if (index < rowMaxCol.value - 1) {
            child[index].style.display = orgDisplay.value[index];
          } else {
            child[index].style.display = 'none';
          }
        });
      }
    }
    var handleResize = debounce(function () {
      setColSpan();
      init();
    }, 300);
    window.addEventListener('resize', handleResize);
    function init() {
      var _rowRef$value;
      var child = _toConsumableArray(((_rowRef$value = rowRef.value) === null || _rowRef$value === void 0 ? void 0 : _rowRef$value.$el.children) || []);
      showExpansion.value = child.length > rowMaxCol.value;
      // // 缓存元素原display
      var formItemChild = getChildren();
      formItemChild.forEach(function (item, index) {
        orgDisplay.value[index] = item.style.display;
      });
    }
    function getChildren() {
      var _rowRef$value2;
      return _toConsumableArray(((_rowRef$value2 = rowRef.value) === null || _rowRef$value2 === void 0 ? void 0 : _rowRef$value2.$el.children) || []).filter(function (item) {
        return item.className.includes('exp-item');
      });
    }
    function setColSpan() {
      if (document.body.clientWidth <= 1500) {
        colspan.value = 8;
      } else {
        colspan.value = 6;
      }
    }
    function validate() {
      return new Promise(function (resolve, reject) {
        var _formRef$value;
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validate(function (valid) {
          if (valid) {
            resolve(valid);
          } else {
            reject(false);
          }
        });
      });
    }
    onMounted(function () {
      setColSpan();
      init();
      handleExpansion();
    });
    onUnmounted(function () {
      window.removeEventListener('resize', handleResize);
    });
    __expose({
      validate: validate
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_IEpArrowDown = _resolveComponent("IEpArrowDown");
      var _component_IEpArrowUp = _resolveComponent("IEpArrowUp");
      var _component_el_col = _resolveComponent("el-col");
      return _openBlock(), _createBlock(_unref(ElForm), _mergeProps(props, {
        "label-width": props.labelWidth || 80
      }), {
        default: _withCtx(function () {
          return [_createVNode(_unref(ElRow), {
            gutter: 20,
            ref_key: "rowRef",
            ref: rowRef
          }, {
            default: _withCtx(function () {
              return [_renderSlot(_ctx.$slots, "default", {
                colspan: _unref(colspan)
              }), _createVNode(_component_el_col, {
                span: _unref(colspan),
                style: {
                  "margin-left": "auto"
                }
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
                    type: "primary",
                    icon: _unref(createIconNode)('Search'),
                    onClick: search
                  }, {
                    default: _withCtx(function () {
                      return _cache[0] || (_cache[0] = [_createTextVNode("查询")]);
                    }),
                    _: 1
                  }, 8, ["icon"]), _createVNode(_component_el_button, {
                    icon: _unref(createIconNode)('Refresh'),
                    onClick: reset
                  }, {
                    default: _withCtx(function () {
                      return _cache[1] || (_cache[1] = [_createTextVNode("重置")]);
                    }),
                    _: 1
                  }, 8, ["icon"]), _unref(showExpansion) ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "expansion",
                    onClick: handleExpansion
                  }, [!_unref(expansion) ? (_openBlock(), _createBlock(_component_IEpArrowDown, {
                    key: 0
                  })) : (_openBlock(), _createBlock(_component_IEpArrowUp, {
                    key: 1
                  })), _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(expansion) ? '收起' : '展开'), 1)])) : _createCommentVNode("", true)])];
                }),
                _: 1
              }, 8, ["span"])];
            }),
            _: 3
          }, 512)];
        }),
        _: 3
      }, 16, ["label-width"]);
    };
  }
});